/**
 * Graphe nav runtime — miroir de Sidebar.tsx (entrées conditionnelles).
 * Source de vérité pour Laika : n'envoyer que ce que le pro voit vraiment.
 */

export type VisibleNavId =
  | 'demarrage'
  | 'accueil'
  | 'planning'
  | 'pension'
  | 'reservations'
  | 'services'
  | 'forfaits'
  | 'billing'
  | 'quotes'
  | 'comptabilite'
  | 'stats'
  | 'marketing'
  | 'clients'
  | 'suivis'
  | 'notes'
  | 'profil'
  | 'associations'
  | 'equipe'
  | 'parametres'
  | 'partenaires'
  | 'asso_planning'
  | 'asso_members'
  | 'asso_clients'
  | 'asso_events'
  | 'asso_messaging'
  | 'asso_cgv'
  | 'asso_settings';

export type VisibleSidebarNavFlags = {
  startupTabVisible: boolean;
  boardingVisible?: boolean;
  iosFreeUser?: boolean;
  billingUi?: boolean;
  marketingTools?: boolean;
  followEngine?: boolean;
  associationMode?: boolean;
  associationMessaging?: boolean;
};

export function isAssociationSidebarPage(page: string): boolean {
  return page.startsWith('association_') && page !== 'association_dashboard';
}

/**
 * Entrées dont la page est un mur ou un upsell Premium.
 * `forfaits` = tout le menu Offres (forfaits, crédits, cartes, abonnements).
 */
export const PREMIUM_SIDEBAR_NAV_IDS = [
  'forfaits',
  'billing',
  'quotes',
  'comptabilite',
  'stats',
  'marketing',
  'notes',
] as const satisfies readonly VisibleNavId[];

export function isPremiumSidebarNav(id: VisibleNavId): boolean {
  return (PREMIUM_SIDEBAR_NAV_IDS as readonly VisibleNavId[]).includes(id);
}

export function buildVisibleSidebarNav(flags: VisibleSidebarNavFlags): VisibleNavId[] {
  if (flags.associationMode) {
    const items: VisibleNavId[] = [
      'asso_planning',
      'asso_members',
      'asso_clients',
      'asso_events',
    ];
    if (flags.associationMessaging !== false) {
      items.push('asso_messaging');
    }
    items.push('asso_cgv', 'asso_settings');
    return items;
  }

  const iosFree = !!flags.iosFreeUser;
  const items: VisibleNavId[] = [];
  if (flags.startupTabVisible) items.push('demarrage');
  items.push('accueil', 'planning');
  if (flags.boardingVisible) items.push('pension');
  items.push('reservations', 'services');
  if (!iosFree) items.push('forfaits');
  if (!iosFree) {
    if (flags.billingUi !== false) {
      items.push('billing', 'quotes');
    }
    items.push('comptabilite', 'stats');
  }
  if (flags.marketingTools) items.push('marketing');
  items.push('clients');
  if (flags.followEngine) items.push('suivis');
  if (!iosFree) items.push('notes');
  items.push('profil');
  if (!iosFree) items.push('associations', 'equipe');
  items.push('parametres');
  if (!iosFree) items.push('partenaires');
  return items;
}
